// Browser entry point. Bundled by esbuild into public/app.js.
import { getConfig } from './api.ts';
import { route, setRenderer, go } from './router.ts';
import { adminView } from './views/admin.ts';
import { friendView } from './views/friend.ts';
import { landingView, type Variant } from './views/landing.ts';
import { partnerView } from './views/partner.ts';
import { homeView } from './views/home.ts';
import { config, newView } from './views/new-split.ts';
import { payerView } from './views/payer.ts';
import { restaurantsView } from './views/restaurants.ts';
import { cardsView } from './views/cards.ts';
import { rememberLink } from './track.ts';
import { fee } from './fee.ts';

setRenderer((path) => {
  let m: RegExpMatchArray | null;
  rememberLink();
  if (path === '/') return homeView();
  if (path === '/new') return newView();
  if (path === '/admin') return adminView();
  if (path === '/restaurants') return restaurantsView();
  if ((m = path.match(/^\/cards\/([A-Za-z0-9]+)$/))) return cardsView(m[1].toUpperCase());
  if ((m = path.match(/^\/l\/([a-z]+)$/))) return landingView(m[1] as Variant);
  if ((m = path.match(/^\/partner\/([A-Za-z0-9_-]+)$/))) return partnerView(m[1]);
  if ((m = path.match(/^\/p\/([A-Za-z0-9]+)$/))) return payerView(m[1].toUpperCase());
  if ((m = path.match(/^\/s\/([A-Za-z0-9]+)$/))) return friendView(m[1].toUpperCase());
  go('/', true);
});

getConfig()
  .then((c) => {
    config.receiptReading = c.receiptReading;
    config.sms = c.sms === true;
    // The server sends just { on: false } while the fee test is off, so the phone keeps FEE_OFF.
    if (c.fee?.on) fee.cfg = c.fee;
    fee.cardsKey = c.cardsKey || '';
    fee.pricing = c.pricing === true;
    // Show which code this page is running, to check it against the latest deploy.
    const el = document.getElementById('version');
    if (el && c.version) {
      // In Mountain Time with a label, where the team is, so it reads the same on every phone
      // (QA's browser showed 11:19 PM, its own zone, for a 9:19 PM MT deploy).
      const when = new Date(c.version.startedAt).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: 'America/Denver' });
      el.textContent = `Version ${c.version.commit} · ${when} MT`;
    }
  })
  .catch(() => { /* reading stays off; people type items in */ })
  .finally(route);
